import { useEffect, useState } from "react";

import { lenderRatingOptions } from "@app/constants";
import { Attribute } from "@graphql/gqlTypes/Attribute";
import { getShopAttributes } from "@utils/ssr";

const defaultOrderColors = ["black", "blue", "pink", "red", "white"];

export const useAttributesFiltering = ({
  categoryId,
  collectionId,
}: {
  categoryId?: string | null | undefined;
  collectionId?: string | null | undefined;
}) => {
  const [attributes, setAttributes] = useState<Attribute[]>([]);

  useEffect(() => {
    const fetchAttributes = async () => {
      const attributesData = await getShopAttributes({
        categoryId,
        collectionId,
      });

      const normalizeAttributesData = attributesData.map((attribute) => {
        if (attribute.slug === "size") {
          return {
            ...attribute,
            startFrom: 1,
          };
        }
        if (attribute.slug === "colour") {
          const values = [...attribute?.values];
          const sortedValues = values.sort((a, b) => {
            const indexOfA = defaultOrderColors.indexOf(a.slug);
            const indexOfB = defaultOrderColors.indexOf(b.slug);
            if (indexOfA === -1) {
              return 1;
            }
            if (indexOfB === -1) {
              return -1;
            }
            return indexOfA < indexOfB ? -1 : 1;
          });

          return {
            ...attribute,
            values: sortedValues,
          };
        }

        return attribute;
      });

      const lenderRatingAttribute = {
        slug: "lenderRating",
        name: "Lender Rating",
        values: lenderRatingOptions,
      };
      setAttributes([...normalizeAttributesData, lenderRatingAttribute]);
    };

    fetchAttributes();
  }, [categoryId, collectionId]);

  return attributes;
};
